import { Employee } from '../models/Employee';

import dnPortraitImage from '../assets/images/employees/Kontakt-DN.webp';
import cjaPortraitImage from '../assets/images/employees/Kontakt-CJA.webp';
import unPortraitImage from '../assets/images/employees/Kontakt-UN.webp';

export const employees: Employee[] = [
  {
    image: dnPortraitImage,
    name: 'Daniel Nussdorf',
    title: 'CEO',
    email: 'daniel.nussdorf@iceberry.se',
  },
  {
    image: unPortraitImage,
    name: 'Ulrica Nyberg',
    title: 'Partner Manager',
    email: 'ulrica.nyberg@iceberry.se',
  },
  {
    image: cjaPortraitImage,
    name: 'Carl Johan Andersson',
    title: 'Site Manager Göteborg',
    email: 'carl.johan.andersson@iceberry.se',
  },
];
